import { Button } from '@/components/ui/button';
import { ServiceModal } from '@/components/ServiceModal';
import {
  getServiceButtonText,
  getServiceImage,
  getServiceInfo,
} from './serviceCatalog';

interface ServiceCardProps {
  service: { service: string; image?: string };
  config: any;
}

export function ServiceCard({ service, config }: ServiceCardProps) {
  const info = getServiceInfo(service.service);
  const IconComponent = info.icon;
  const serviceImage = getServiceImage(service, info);

  return (
    <article className="wl7-service-card">
      {serviceImage && (
        <div className="wl7-service-card__media">
          <img src={serviceImage} alt={info.title} loading="lazy" />
          <div className="wl7-service-card__overlay" aria-hidden="true" />
          <div className={`wl7-service-card__icon ${info.color}`}>
            <IconComponent className="h-5 w-5 text-white" />
          </div>
          <h3 className="wl7-service-card__title">{info.title}</h3>
        </div>
      )}

      <div className="wl7-service-card__body">
        <p className="wl7-service-card__description">{info.description}</p>
        <ServiceModal
          service={service}
          serviceTitle={info.title}
          config={config}
          serviceImage={serviceImage}
        >
          <Button className="wl7-service-card__btn w-full rounded-lg font-semibold h-11 shadow-md hover:shadow-lg transition-all duration-300">
            {getServiceButtonText(service.service)}
          </Button>
        </ServiceModal>
      </div>
    </article>
  );
}
